import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { ImageUrl, BaseImgUploadUrl } from "../../formcomponents/Constants";
const ImageFileIdUpload = (props) => {
  const [uploadPercentage, setuploadPercentage] = useState(0);
  const [imagePath, setimagePath] = useState();
  const uploadImage = (e) => {
    // seterrorMsg("");
    const file = e.target.files[0];
    const formdata = new FormData();
    formdata.append("file", file);

    axios
      .post(BaseImgUploadUrl, formdata, {
        onUploadProgress: (progressEvent) => {
          const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setuploadPercentage(percentage);
        },
      })
      .then((res) => {
        console.log("response", res.data); //fileName
        setimagePath(res.data.fileName);
        props.onChange(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <Fragment>
      <label className="form-label" htmlFor="name">
        {props.label}
      </label>{" "}
      <input
        type="file"
        placeholder={props.label}
        onChange={(e) => uploadImage(e)}
      />
      {uploadPercentage > 0 && (
        <div className="progress" style={{ marginTop: "20px" }}>
          <div
            className="progress-bar bg-success"
            role="progressbar"
            style={{ width: `${uploadPercentage}%` }}
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          />
        </div>
      )}
      {uploadPercentage == 100 && (
        <img src={ImageUrl + imagePath} height="150px" width="150px" />
      )}
      <div className="err-msg">
        {props.touched && props.error && (
          <span
            style={{
              color: "red",
            }}
          >
            {props.error}
          </span>
        )}
      </div>
    </Fragment>
  );
};

const ImageUploadField = (props) => {
  const {
    placeholder,
    label,
    meta: { touched, error },
    fileurl,
    input,
  } = props;
  return (
    <ImageFileIdUpload
      label={label}
      onChange={input.onChange}
      value={input.value}
      placeholder={placeholder}
      touched={touched}
      error={error}
      input={{ ...input }}
    />
  );
};

export default ImageUploadField;
